import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="bg-weddmac-dark min-h-screen font-inter">
      {/* Optional: very subtle gradient from top for depth */}
      <div className="fixed inset-0 pointer-events-none bg-gradient-to-b from-weddmac-gold/[0.02] via-transparent to-transparent h-64" aria-hidden="true" />
      <Header />
      <main className="relative pt-14 sm:pt-16 md:pt-24 lg:pt-28 min-h-[50vh] sm:min-h-[60vh]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
